export const TAB = {
  EDITOR: 'editor',
  PREVIEW: 'preview',
  RAW: 'raw',
  SAVE: 'save'
}
